import React from 'react';
import { Trans } from '@lingui/react';

export default {
    selectAll: <Trans>Select all</Trans>,
    noStudentsAssigned: <Trans>No students assigned</Trans>,
    removeFromClass: <Trans>Remove from class</Trans>,
    unassignButtonTitle: ['The selected students will be removed from this class',
        '(unassigned) and may lose access to the current product.'].join(' ')
};



// WEBPACK FOOTER //
// ./components/class-group-students/class-group-students-text.js